import { Heading, TextLink } from '@mm/components';
import { InfoIcon } from '@mm/icons';
import connectedPageCRUDActions from '@mm/state/actions/ConnectedPageCRUDActions';
import { UserRole } from '@mm/state/model/CompanyUsersModel';
import { selectInstagramAccountId } from '@mm/state/selectors/instagramSelectors';
import { activeCompanySelector } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import React, { useMemo } from 'react';
import { connect, useSelector } from 'react-redux';
import { compose } from 'recompose';
import { Dispatch } from 'redux';
import { CategoryOverride } from './CategoryOverride/CategoryOverride';
import { InstagramAccountConnectionStatus } from './DisconnectInstagramAccount/InstagramAccountConnectionStatus';
import FacebookConnectionStatus from './FacebookConnectionStatus/FacebookConnectionStatus';
import './MaintenanceSettingsSection.pcss';
import TransformPage from './TransformPage/TransformPage';

type OuterProps = {};

type InnerProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

type Props = OuterProps & InnerProps;

const MaintenanceSettingsSection = (props: Props) => {
  const { company, companyUsers, session, refreshAccessToken, connectedPage } =
    props;

  const instagramAccountId = useSelector(selectInstagramAccountId);

  const canTransformPage = useMemo(() => {
    const currentUser = companyUsers.find(user => user.id === session.id);

    return (
      currentUser &&
      (currentUser.role === UserRole.Admin ||
        currentUser.role === UserRole.Owner)
    );
  }, [companyUsers, session]);

  if (connectedPage) {
    return (
      <div className="maintenance-settings-section">
        <Heading size={3} text="Maintenance" />
        <TextLink icon={<InfoIcon />}>
          Provide the main data for displaying your company
        </TextLink>
        {connectedPage && (
          <CategoryOverride
            facebookPageId={connectedPage.id}
            category={connectedPage.mmCategory}
          />
        )}
        {company && canTransformPage && connectedPage && (
          <TransformPage
            facebookPageId={connectedPage.id}
            facebookPageName={connectedPage.name || 'N/A'}
            companyId={company.id}
          />
        )}

        {company && company.editable && (
          <FacebookConnectionStatus
            connectedPage={connectedPage}
            refreshAccessToken={refreshAccessToken}
            companyId={company.id}
          />
        )}
        {instagramAccountId && (
          <InstagramAccountConnectionStatus page={connectedPage} />
        )}
      </div>
    );
  }

  return null;
};

const mapStateToProps = (state: StoreState) => ({
  company: activeCompanySelector(state),
  connectedPage: state.connectedPage.pageDetails,
  companyUsers: state.companyUsers.entities,
  session: state.session.session,
});

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
  refreshAccessToken: (pageId: number) =>
    dispatch(connectedPageCRUDActions.refreshAccessToken(pageId)),
});

const enhance = compose<InnerProps, OuterProps>(
  connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(MaintenanceSettingsSection);
